import { ReactElement } from "react";
import Drawer from "@mui/material/Drawer";
import { toggleRightPanel } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import { IState } from "../types";
import LanguageComponent from "./headerComponents/languageComponent";
import NotificationComponent from "./headerComponents/notificationComponent";
import ThemeSelector from "./headerComponents/themeSelector";

const RightPanel = (): ReactElement => {
  const dispatch = useDispatch<any>();
  const open = useSelector((state: IState) => state.panels.right);

  return(
    <Drawer className="lateral-panel" anchor="right" open={open} onClose={() => dispatch(toggleRightPanel())}>
      <div className="lateral-panel">

        <LanguageComponent />
        <NotificationComponent/>
        <ThemeSelector />

      </div>
    </Drawer>
  );
};

export default RightPanel;
